<template>
    <div>
        <div class="tw-relative tw-w-full tw-h-full ">
            <div class="tw-absolute tw-top-2 tw-right-2 tw-z-10 tw-flex tw-items-center tw-gap-2">
                <div class="tw-flex tw-items-center tw-gap-2">
                    <button @click.stop="onBookmark" :disabled="bookmarkLoading" aria-label="Bookmark" 
                    :class="[bookmarked ? '!tw-text-primary-600' : 'tw-text-gray-400']"
                    class="tw-w-8 tw-h-8 tw-rounded-md tw-bg-white tw-border tw-border-solid tw-border-transparent hover:tw-border-gray-200 tw-duration-200 tw-text-gray-400 hover:tw-text-gray-700 tw-flex tw-items-center tw-justify-center">
                        <icon :icon="bookmarkLoading ? 'eos-icons:three-dots-loading' : 'solar:bookmark-bold-duotone'" class="tw-w-5 tw-h-5" />
                    </button>
                </div>
                <!-- connection status -->
                <div v-if="false">
                    <!-- Pending Connection -->
                    <button
                        v-if="member.connection?.status === 'pending'"
                        disabled
                        class="tw-w-8 tw-h-8 tw-rounded-md tw-bg-amber-50 tw-border tw-border-solid tw-border-amber-200 tw-text-amber-600 tw-flex tw-items-center tw-justify-center">
                        <icon icon="solar:clock-circle-bold" class="tw-w-5 tw-h-5" />
                    </button>
    
                    <!-- Accepted Connection -->
                    <button
                        v-else-if="member.connection?.status === 'accepted'"
                        disabled
                        class="tw-w-8 tw-h-8 tw-rounded-md tw-bg-green-50 tw-border tw-border-solid tw-border-green-200 tw-text-green-600 tw-flex tw-items-center tw-justify-center">
                        <icon icon="solar:check-circle-bold" class="tw-w-5 tw-h-5" />
                    </button>
    
                    <!-- Connect Button -->
                    <button
                        v-else-if="member.connection?.can_connect !== false"
                        @click.prevent="showConnectionPopup = true"
                        class="tw-w-8 tw-h-8 tw-rounded-md tw-bg-white tw-border tw-border-solid tw-border-transparent hover:tw-border-gray-200 tw-duration-200 tw-text-gray-400 hover:tw-text-gray-700 tw-flex tw-items-center tw-justify-center">
                        <icon icon="solar:user-plus-bold-duotone" class="tw-w-5 tw-h-5" />
                    </button>
                </div>
            </div>
            <router-link :to="{ name: 'shared.community-member', params: { id: member.id } }"
                class="tw-w-full tw-block tw-relative tw-group tw-h-full tw-bg-white tw-border tw-border-primary-200 tw-rounded-lg tw-duration-200 hover:tw-shadow-md hover:tw-border-primary-300 tw-cursor-pointer ">
                <div class="tw-flex tw-items-center tw-gap-3 tw-px-4 tw-pt-4">
                    <div :class="roleColors.ring"
                        class="tw-w-24 tw-h-24 tw-rounded-full tw-bg-gray-200 tw-mx-auto tw-mt-2 tw-border-4 tw-ring tw-border-solid group-hover:tw-border-primary-400x tw-duration-200 tw-relative">
                        <img :src="member.profile_image" alt="member avatar" class="tw-w-full tw-h-full tw-rounded-full">
    
                        <!-- Curved Role Badge -->
                        <div class="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center -tw-rotate-45">
                            <svg class="tw-w-full tw-h-full tw-absolute -tw-bottom-3.5" viewBox="0 0 100 100">
                                <defs>
                                    <path id="bottom-arc" d="M 15,75 A 50,50 0 0,0 85,75" />
                                </defs>
                                <text :class="[roleColors.stroke, roleColors.text]" class="tw-text-[16px] tw-font-black"
                                    text-anchor="middle" stroke-width="0.8" letter-spacing="1">
                                    <textPath href="#bottom-arc" startOffset="50%">
                                        {{ member.badge }}
                                    </textPath>
                                </text>
                            </svg>
                        </div>
                    </div>
                </div>
                <div
                    class="tw-flex tw-items-center tw-justify-center tw-mt-4 tw-flex-col tw-border-t tw-border-gray-200 tw-pb-4 tw-pt-2">
                    <h1 class="tw-text-lg tw-font-semibold tw-text-gray-900 tw-mb-1 tw-mx-auto tw-px-2">{{ member.name }}
                    </h1>
                    <p v-if="member.company?.name" class="tw-text-sm tw-text-gray-500">{{ member.company.name }}</p>
                    <p v-else class="tw-text-sm tw-text-gray-500">-</p>
                </div>
            </router-link>
        </div>
    
        <!-- Connection Request Popup -->
        <ConnectionRequestPopup
            :visible="showConnectionPopup"
            :target-user="member"
            @close="showConnectionPopup = false"
            @sent="handleConnectionSent"
        />
    </div>
</template>

<script setup>
import { defineProps, computed, ref } from 'vue';
import { roleColorMap } from '@/config/params';
import ConnectionRequestPopup from '@/components/notifications/modals/ConnectionRequestPopup.vue';
import bookmarksApi from '@/api/bookmarks';

const props = defineProps({
    member: {
        type: Object,
        required: true
    }
});

const bookmarked = ref(props.member.is_bookmarked);
const bookmarkLoading = ref(false);

const onBookmark = async () => {
    bookmarkLoading.value = true;

    await bookmarksApi.toggle({
        bookmarkable_type: 'user',
        bookmarkable_id: props.member.id
    })

    bookmarked.value = !bookmarked.value;
    bookmarkLoading.value = false;
}
// Connection popup state
const showConnectionPopup = ref(false);

// Role color mapping
const roleColors = computed(() => {
    const role = props.member.role?.toLowerCase() || 'default';
    return roleColorMap[role] || roleColorMap.default;
});

// Handle successful connection request
const handleConnectionSent = () => {
    // Additional handling if needed
};
</script>
